import { render, staticRenderFns } from "./GrowerPricingPARDelete.vue?vue&type=template&id=bb4061ac"
import script from "./GrowerPricingPARDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./GrowerPricingPARDelete.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports